<template>
  <v-container style="height: 400px">
    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
    >
      <v-col
        class="text-subtitle-1 text-center"
        cols="12"
      >
        <span v-text="$t('alerts.pleaseWait')" />
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="info"
          height="16"
          indeterminate
          rounded
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TheAppLoader',
};
</script>
